import addProductSopBaseUnitListImage from "../../../assets/images/add-product-sop/add-product-sop-base-unit-list.png";
import addProductSopBaseUnitSelectedImage from "../../../assets/images/add-product-sop/add-product-sop-base-unit-selected.png";
import addProductSopCategoryImage from "../../../assets/images/add-product-sop/add-product-sop-category.png";
import addProductSopNewCategoryFormImage from "../../../assets/images/add-product-sop/add-product-sop-new-category-form.png";
import addProductSopNewCategoryImage from "../../../assets/images/add-product-sop/add-product-sop-new-category.png";
import addProductSopOpenModalImage from "../../../assets/images/add-product-sop/add-product-sop-open-modal.png";
import addProductSopPartialSellingImage from "../../../assets/images/add-product-sop/add-product-sop-partial-selling.png";
import addProductSopSellingModeImage from "../../../assets/images/add-product-sop/add-product-sop-selling-mode.png";

import type { AddProductSopImageConfig } from "../types";

export const ADD_PRODUCT_SOP_IMAGES: Record<string, AddProductSopImageConfig> =
  {
    "open-modal": {
      src: addProductSopOpenModalImage,
      altKey: "add-product-sop-image-open-modal-alt",
      altFallback:
        "Add New Product form showing Selling Mode, Store, Category, Base Unit, and Partial Selling Allowed fields"
    },
    "selling-mode": {
      src: addProductSopSellingModeImage,
      altKey: "add-product-sop-image-selling-mode-alt",
      altFallback:
        "Selling Mode dropdown showing Single Item, Unit Based (Piece), and Measured Quantity options"
    },
    category: {
      src: addProductSopCategoryImage,
      altKey: "add-product-sop-image-category-alt",
      altFallback:
        "Category dropdown with an add-new-category button beside the field"
    },
    "new-category": {
      src: addProductSopNewCategoryImage,
      altKey: "add-product-sop-image-new-category-alt",
      altFallback: "New Category modal opened from the Add New Product form"
    },
    "new-category-form": {
      src: addProductSopNewCategoryFormImage,
      altKey: "add-product-sop-image-new-category-form-alt",
      altFallback:
        "New Category form showing Category Name, Description, and Parent Category fields"
    },
    "base-unit-list": {
      src: addProductSopBaseUnitListImage,
      altKey: "add-product-sop-image-base-unit-list-alt",
      altFallback:
        "Base Unit dropdown listing gram, kilogram, liter, meter, and other measured units"
    },
    "base-unit-selected": {
      src: addProductSopBaseUnitSelectedImage,
      altKey: "add-product-sop-image-base-unit-selected-alt",
      altFallback:
        "Base Unit set to Centimeter with Partial Selling Allowed field visible"
    },
    "partial-selling": {
      src: addProductSopPartialSellingImage,
      altKey: "add-product-sop-image-partial-selling-alt",
      altFallback: "Partial Selling Allowed dropdown showing Yes and No options"
    }
  };
